module.exports = __webpack_public_path__ + "img/desktop.0017737e.png";